export default "__VITE_ASSET__CErU9SXl__"